export const IMAGES_GET = "IMAGES_GET";
export const IMAGES_GET_SUCCESS = "IMAGES_GET_SUCCESS";
export const IMAGE_DELETE = "IMAGE_DELETE";
export const IMAGE_DELETE_SUCCESS = "IMAGE_DELETE_SUCCESS";
export const IMAGE_API_ERROR = "IMAGE_API_ERROR";
export const IMAGE_SET_LOADED = "IMAGE_SET_LOADED";
